import { Box, Button, Divider, Typography } from "@mui/material";

interface EditMenuItemHeaderProps {
  title: string;
  handleClose: () => void;
  handleSave: () => void;
  handleDuplicate: () => void;
}

export const EditMenuItemHeader = ({ title, handleClose, handleSave, handleDuplicate }: EditMenuItemHeaderProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, gap: 2, overflowY: "hidden" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h2">{title}</Typography>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="outlined" onClick={handleDuplicate}>
            Duplicate
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </Box>
      </Box>
      <Divider />
    </Box>
  );
};
